export const xAxisLabelTooltipPlugin = {
  id: "xAxisLabelTooltip",
  afterEvent(chart, args) {
    const event = args.event;
    const canvas = chart.canvas;
    const labels = chart.data.labels;
    const xAxis = chart.scales?.x;

    if (!xAxis || !labels || !canvas) return;

    // Create tooltip element once
    if (!canvas._xAxisTooltip) {
      const tooltipEl = document.createElement("div");
      tooltipEl.style.position = "absolute";
      tooltipEl.style.background = "#333";
      tooltipEl.style.color = "#fff";
      tooltipEl.style.padding = "4px 8px";
      tooltipEl.style.borderRadius = "4px";
      tooltipEl.style.fontSize = "12px";
      tooltipEl.style.pointerEvents = "none";
      tooltipEl.style.whiteSpace = "nowrap";
      tooltipEl.style.display = "none";
      tooltipEl.style.zIndex = 1000;
      document.body.appendChild(tooltipEl);
      canvas._xAxisTooltip = tooltipEl;
    }

    const tooltipEl = canvas._xAxisTooltip;

    if (event.type === "mousemove") {
      const rect = canvas.getBoundingClientRect();
      const x = event.x - rect.left;
      const y = event.y - rect.top;

      const index = labels.findIndex((_, i) => {
        const tickX = xAxis.getPixelForTick(i);
        const tickWidth = xAxis.width / labels.length;

        return (
          x >= tickX - tickWidth / 2 &&
          x <= tickX + tickWidth / 2 &&
          y >= xAxis.bottom &&
          y <= xAxis.bottom + 30
        );
      });

      if (index !== -1) {
        tooltipEl.innerHTML = labels[index];
        tooltipEl.style.left = `${event.x + 10}px`;
        tooltipEl.style.top = `${event.y + 10}px`;
        tooltipEl.style.display = "block";
      } else {
        tooltipEl.style.display = "none";
      }
    } else if (event.type === "mouseout") {
      tooltipEl.style.display = "none";
    }
  },
};

export const getCategoriesPerClientOptions = (weekPartGraph, yLabel) => {
  const datasets = weekPartGraph?.datasets || [];
  const maxValue =
    Math.max(...datasets.flatMap((dataset) => dataset.data), 0) + 1;

  return {
    aspectRatio: 3,
    plugins: {
      xAxisLabelTooltip: true,
      legend: {
        display: false,
        position: "top",
        align: "start",
        labels: {
          padding: 15,
          font: { size: 12, weight: "bold" },
          color: "#6C757D",
        },
      },
      tooltip: {
        callbacks: {
          title: (tooltipItems) => {
            const index = tooltipItems[0].dataIndex;
            return weekPartGraph.labels[index] || "";
          },
          label: (tooltipItem) => {
            const datasetIndex = tooltipItem.datasetIndex;
            const dataValue = tooltipItem.raw; // Get the value of the data point
            return `${weekPartGraph.datasets[datasetIndex].label}: ${dataValue}`;
          },
        },
      },
      datalabels: {
        color: "#000",
        anchor: "end",
        align: "top",
        font: { weight: "bold", size: 0 },
        formatter: (value) => (value !== 0 ? value : ""),
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        suggestedMax: maxValue,
        title: {
          display: true,
          text: yLabel,
          font: { size: 12, weight: "bold" },
        },
        ticks: {
          callback: (value) =>
            yLabel === "% OF TOTAL" ? `${value}%` : `${value}`,
          font: { size: 12, weight: "bold" },
          stepSize: 1,
        },
      },
      x: {
        ticks: {
          font: { size: 12, weight: "bold" },
          callback: (value, index) => {
            const label = weekPartGraph.labels[index] || "";
            return label.length > 20 ? label.slice(0, 20) + "..." : label;
          },
          maxRotation: 45,
          minRotation: 45,
        },
      },
    },
  };
};
